import { render } from "./LoaderPage.vue?vue&type=template&id=75afcf82&scoped=true"
import script from "./LoaderPage.vue?vue&type=script&lang=js"
export * from "./LoaderPage.vue?vue&type=script&lang=js"

import "./LoaderPage.vue?vue&type=style&index=0&id=75afcf82&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2304645743/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75afcf82"]])

export default __exports__